module.exports = __webpack_public_path__ + "img/J13312.1fbd652a.png";